import { useCallback, useEffect, useState } from 'react';
import { ManagedAccountsApi } from '@/api/clients/managed-accounts/managed-accounts.api';

export const useGetManagedAccounts = (type) => {
  const [managedAccounts, setManagedAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchManagedAccounts = useCallback(() => {
    setLoading(true);
    setError(null);

    return ManagedAccountsApi.list(type)
      .then((response) => {
        setManagedAccounts(response.data.data || []);
      })
      .catch((requestError) => {
        setError(
          requestError.response?.data?.message ||
            'Failed to load the managed accounts',
        );
        setManagedAccounts([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [type]);

  useEffect(() => {
    fetchManagedAccounts();
  }, [fetchManagedAccounts]);

  return {
    managedAccounts,
    loading,
    error,
    refetch: fetchManagedAccounts,
  };
};
